import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import Processing from "../../components/processing/processing";
import { useLocation } from "react-router-dom";
import { API } from "../../api/api";
import constants from '../../utils/contants';

const LocationTab = () => {

    const [isEditable, setIsEditable] = useState(false);
    const [buttonValue, setButtonValue] = useState("Edit");
    const { state } = useLocation();
    const { driver } = state;

    useEffect(() => {
        getUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getUserData = () => {
        // setLoading(true);
        formik.setFieldValue("firstname", driver?.firstname);
        formik.setFieldValue("lastname", driver?.lastname);
        formik.setFieldValue("vehicle", driver?.car_info?.car_type?._id);
        formik.setFieldValue("email", driver?.email);
        formik.setFieldValue("phone", driver?.phone_no);
        formik.setFieldValue("status", driver?.is_send_request);
        // setLoading(false);
    };

    const validationSchema = Yup.object().shape({
        firstname: Yup.string().required("Please Enter Username"),
        lastname: Yup.string().required("Please Enter Username"),
        email: Yup.string().required("Please Enter email"),
        phone: Yup.number().required().positive().integer(),
        vehicle: Yup.string().required("Please Enter Vehicle"),
        status: Yup.string().required("Please Enter Status"),
    });

    const formik = useFormik({
        initialValues: {
            firstname: "",
            lastname: "",
            email: "",
            vehicle: "",
            phone: "",
            status: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const body = {
                // id: driver?._id,
                firstname: values?.firstname,
                lastname: values?.lastname,
                email: values?.email,
                car_info: {
                    car_type: values?.vehicle
                },
                phone_no: values?.phone,
                is_send_request: values?.status
            };
            API(`update-driver/${driver?._id}`, "put", body, localStorage.getItem(constants.TOKEN))
                .then((res) => {
                    toast.success("Driver Details updated successfully ✅", {
                        position: toast.POSITION.TOP_RIGHT,
                        className: "bg-success text-white",
                    });
                    // navigate("/manage-driver");
                })
                .catch((error) => {
                    toast.error("Error while updating Driver Details", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    console.log("error: ", error);
                });
        },
    });

    const enableEditing = () => {
        setIsEditable(true);
        setButtonValue("Update");
    };



    return (
        <>
            <hr className="mt-4" />
            <div className="advice_form text-black select_visible">
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Location</label>
                    <input
                        type="text"
                        name="firstname"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.firstname}
                        onChange={(e) => {
                            formik.setFieldValue("firstname", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.firstname && formik.errors.firstname && (
                        <div className="text-danger">{formik.errors.firstname}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Satus</label>
                    <input
                        type="text"
                        name="lastname"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.lastname}
                        onChange={(e) => {
                            formik.setFieldValue("lastname", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.lastname && formik.errors.lastname && (
                        <div className="text-danger">{formik.errors.lastname}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Online</label>
                    <input
                        type="text"
                        name="email"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.email}
                        onChange={(e) => {
                            formik.setFieldValue("email", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                    )}
                </div>
                
                <div className="d-flex mt-5 justify-content-end gap-4">
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        disabled={
                            buttonValue === "Update" &&
                            formik.values.firstname === driver?.firstname &&
                            formik.values.lastname === driver?.lastname &&
                            formik.values.email === driver?.email &&
                            formik.values.phone === driver?.phone_no &&
                            formik.values.vehicle === driver?.car_info?.car_type?.name
                        }
                        onClick={
                            buttonValue === "Update" ? formik.handleSubmit : enableEditing
                        }
                    >
                        {buttonValue}
                    </button>
                </div>
            </div>
        </>
    )
}

export default LocationTab